import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const archiveEvent = async (uuid: string) => {
  const response = await CustomAxios.post(`events/${uuid}/archive`);
  return response.data;
};

interface UseArchiveEventProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useArchiveEvent({ uuid, onSuccessCallback }: UseArchiveEventProps) {
  return useMutation({
    mutationFn: () => archiveEvent(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEvents, uuid] });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to archive the event. Please try again and contact support if the problem persists.');
      }
    },
  });
}
